import {Toggle as PeacockToggle} from '@pepsico-ds/ui'
import './Toggle.scss'
/**
 * @typedef {import('@pepsico-ds/ui').IToggleProps} ToggleProps
 * @property {boolean} [checked] Checked state of the toggle.
 * @property {boolean} [disabled] When true, toggle is disabled.
 * @property {string} [label] Additional label text for the toggle.
 * @property {(checked: boolean) => void} [onUpdate] Callback triggered when toggle value changes.
 * @property {'medium' | 'small'} [size] Toggle size.
 * @property {boolean} [showSkeleton] Renders skeleton state.
 * @property {string} [value] Short description/value for the toggle action.
 * @property {'horizontal' | 'vertical'} [variant] Toggle layout direction.
 * @property {boolean} [showCheckedIcon] Whether checked icon is displayed.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Toggle.
 * Supports all Peacock DS toggle props.
 * @param {ToggleProps} props
 */
export const Toggle = props => {
  return <PeacockToggle {...props} />
}
